import { render, staticRenderFns } from "./ToPayVatSettings.vue?vue&type=template&id=b37b496c&scoped=true"
import script from "./ToPayVatSettings.vue?vue&type=script&lang=ts"
export * from "./ToPayVatSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37b496c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b37b496c')) {
      api.createRecord('b37b496c', component.options)
    } else {
      api.reload('b37b496c', component.options)
    }
    module.hot.accept("./ToPayVatSettings.vue?vue&type=template&id=b37b496c&scoped=true", function () {
      api.rerender('b37b496c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/ToPayVatSettings.vue"
export default component.exports